import { createFileRoute, notFound, redirect } from "@tanstack/react-router";

import { GlossaryPage } from "../components/glossary/GlossaryPage";
import { glossaryHead } from "../lib/glossary/head";
import {
  glossaryPath,
  glossarySlugOf,
  loadGlossary,
} from "../lib/glossary/index";
import { GLOSSARY_UI } from "../lib/glossary/ui";
import { siteLangOf } from "../lib/marketing/registry";
import { documentHeaders } from "../lib/seo";
import { loadToolCopy } from "../lib/tools/index";

/** `/<lang>/glossary/<slug>`. Same 301 rule as every other localized route. */
export const Route = createFileRoute("/$lang/glossary/$slug")({
  loader: async ({ params }) => {
    const lang = siteLangOf(params.lang);
    if (!lang) throw notFound();
    const slug = glossarySlugOf(params.slug);
    if (!slug) throw notFound();

    const path = glossaryPath(slug, lang);
    if (path !== `/${params.lang}/glossary/${params.slug}`)
      throw redirect({ href: path, statusCode: 301 });

    const bundle = await loadGlossary(lang);
    const toolCopy = bundle[slug].tool ? await loadToolCopy(lang) : null;
    return { lang, slug, bundle, toolCopy };
  },
  headers: documentHeaders,
  head: ({ loaderData }) =>
    loaderData
      ? glossaryHead(
          loaderData.slug,
          loaderData.lang,
          loaderData.bundle[loaderData.slug],
          GLOSSARY_UI[loaderData.lang],
        )
      : {},
  component: LocalizedTerm,
});

function LocalizedTerm() {
  const { lang, slug, bundle, toolCopy } = Route.useLoaderData();
  return (
    <GlossaryPage
      slug={slug}
      entry={bundle[slug]}
      ui={GLOSSARY_UI[lang]}
      lang={lang}
      bundle={bundle}
      toolCopy={toolCopy}
    />
  );
}
